import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { RootState } from '../redux/store'

const PublicRoute = () => {
    const {token} = useSelector((store: RootState) => store.auth)
    if (token) return <Navigate to="/" />
    return <Outlet />
}

export default PublicRoute